import { apiClient } from './apiClient';

export type SupportInboundMessage = {
  id: string;
  channel: string;
  externalMessageId: string;
  externalConversationId?: string | null;
  fromAddress: string;
  subject?: string | null;
  bodyText: string;
  processingStatus: string;
  triageDecision?: string | null;
  resultingTicketId?: string | null;
  errorMessage?: string | null;
  receivedAtUtc: string;
  processedAtUtc?: string | null;
  attachmentCount: number;
};

export type SupportInboundAttachment = {
  id: string;
  fileName: string;
  contentType: string;
  fileSizeBytes: number;
  fileExtension?: string | null;
  promotedToTicketAttachmentId?: string | null;
  createdAtUtc: string;
};

export type SupportInboundAttachmentDownload = {
  downloadUrl: string;
  fileName: string;
  contentType: string;
  expiresAtUtc: string;
};

export type SupportInboundMessageListResult = {
  items: SupportInboundMessage[];
  totalCount: number;
  page: number;
  pageSize: number;
};

export async function listInboundMessages(params?: {
  status?: string;
  ticketId?: string;
  page?: number;
  pageSize?: number;
}): Promise<SupportInboundMessageListResult> {
  const response = await apiClient.get<SupportInboundMessageListResult>('/v1/customer-success/inbound', {
    params,
  });
  return response.data;
}

export async function reprocessInboundMessage(id: string): Promise<void> {
  await apiClient.post(`/v1/customer-success/inbound/${id}/reprocess`);
}

export async function listInboundMessageAttachments(
  messageId: string,
): Promise<SupportInboundAttachment[]> {
  const response = await apiClient.get<SupportInboundAttachment[]>(
    `/v1/customer-success/inbound/${messageId}/attachments`,
  );
  return response.data;
}

export async function getInboundAttachmentDownloadUrl(
  messageId: string,
  attachmentId: string,
): Promise<SupportInboundAttachmentDownload> {
  const response = await apiClient.get<SupportInboundAttachmentDownload>(
    `/v1/customer-success/inbound/${messageId}/attachments/${attachmentId}/download-url`,
  );
  return response.data;
}
